// extracted by mini-css-extract-plugin
export default {"content":"Footer_content__y1AKS","writeBtn":"Footer_writeBtn__wBrCA","writeImg":"Footer_writeImg__jiKui","textBtn":"Footer_textBtn__2vcXU"};